import React from "react";
import TagsModal from "../TagsModal";
import { MenuItems } from "../../@types";
import { useSetAllTagsSearch } from "../hooks";
import { Sort, Selections } from "../../../modules/search/@types";

type TagsEditAllSearchProps = {
  sort: Sort | undefined;
  selections: Selections | undefined;
  query: string;
  show: boolean;
  handleShow: () => boolean;
};

const TagsEditAllSearch = ({
  sort,
  selections,
  query,
  show,
  handleShow
}: TagsEditAllSearchProps) => {
  const { mutate: setAllTagsSearch } = useSetAllTagsSearch();

  const onFormSubmit = (selectedTags: MenuItems) => {
    setAllTagsSearch({ sort, selections, query, selectedTags });
  };

  return (
    <TagsModal
      show={show}
      handleShow={handleShow}
      onFormSubmit={onFormSubmit}
    />
  );
};

export default TagsEditAllSearch;
